/**
 * Client-side liveness verdict for a realtime WebSocket. The browser keeps a
 * half-open TCP connection in readyState OPEN for minutes after a sleep/wake
 * or network switch, so "the socket is open" proves nothing. The gateway
 * answers every application ping (control) and heartbeat (device) with a
 * frame, so a healthy socket always produces inbound traffic at least once
 * per interval — silence across two full intervals means the connection is
 * dead and must be forced closed so the reconnect path takes over.
 */

/** Missed-interval multiplier before a socket is declared dead. */
export const LIVENESS_MISSED_INTERVALS = 2;

/** Fixed slack for scheduling jitter (timers clamped in background tabs). */
export const LIVENESS_SLACK_MS = 5_000;

export function shouldForceReconnect(
  lastInboundAtMs: number,
  nowMs: number,
  pingIntervalMs: number,
): boolean {
  const silence = nowMs - lastInboundAtMs;
  return (
    silence > pingIntervalMs * LIVENESS_MISSED_INTERVALS + LIVENESS_SLACK_MS
  );
}
